import { documentId } from "firebase/firestore";
import { buildListQueries, LIST_PAGE_SIZE } from "../utils/listQuery";

export const QUOTE_INDEX_PAGE_SIZE = LIST_PAGE_SIZE;

export function buildLegacyQuoteIndexPageQuery(reference, cursor = null) {
  return buildLegacyQuoteIndexQueries(reference, cursor).pageQuery;
}

export function buildLegacyQuoteIndexQueries(reference, cursor = null) {
  return buildListQueries(reference, {
    // Legacy lifecycle flags are inconsistent; filter eligibility after each
    // explicit bounded page so an absent deleted field cannot hide a record.
    order: [[documentId(), "asc"]], cursor,
  });
}

export function buildQuoteIndexQueries(reference, mode, cursor = null) {
  const direction = mode.orderDirection || "desc";
  return buildListQueries(reference, {
    filters: mode.filterField ? [[mode.filterField, "==", mode.filterValue]] : [],
    order: [[mode.orderField, direction], [documentId(), direction]], cursor,
  });
}

export function buildQuoteIndexPageQuery(reference, mode, cursor = null) {
  return buildQuoteIndexQueries(reference, mode, cursor).pageQuery;
}

export function quoteIndexPageHasMore(rawCount) {
  return rawCount === QUOTE_INDEX_PAGE_SIZE;
}

export function mergeQuoteIndexPages(previous, next) {
  const seen = new Set();
  return [...previous, ...next].filter((record) => {
    const key = String(record.sourceQuoteId || record.quoteId || record.id || record.quoteIndexId || "");
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
